"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function onLoad(onLoad) {
    document.addEventListener("load.matrix", function (e) {
        onLoad(e.detail);
    });
}
exports.onLoad = onLoad;
